import React, { useEffect, useRef } from 'react';
import "./CSS/QuestionPrompt.css"
import { v4 as uuidv4 } from 'uuid';

const QuestionPrompt = ({problem, output, rightHalfRef}) => {

    return (
    <div className='prompt'>
        <div>
            <h2>{problem.name}</h2>
            <p><b>Description:</b> {problem.description}</p>
            <p><b>Difficulty:</b> {problem.difficulty}</p>
            <p><b>Tags:</b> {problem.tags.map((tag,idx) => {
                return <span key={uuidv4()} >{tag} {problem.tags.length === idx - 1 ? "." : ", "} </span>
            })}</p>
        </div>

        <div className='output-container'>
            <textarea readOnly value={output} className="textarea-content"></textarea>
        </div>
    </div>
    )
};

export default QuestionPrompt;
